var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPaperSuperBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3346 43.6693H47.668V47.0026H34.3346V43.6693ZM34.3346 37.0026H47.668V40.3359H34.3346V37.0026ZM44.3346 20.3359H31.0013C29.168 20.3359 27.668 21.8359 27.668 23.6693V50.3359C27.668 52.1693 29.1513 53.6693 30.9846 53.6693H51.0013C52.8346 53.6693 54.3346 52.1693 54.3346 50.3359V30.3359L44.3346 20.3359ZM51.0013 50.3359H31.0013V23.6693H42.668V32.0026H51.0013V50.3359Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaperSuperBigCircle);
export default __webpack_public_path__ + "static/media/ic_paper_super_big_circle.531ece381805e24e26047f6863ecaac8.svg";
export { ForwardRef as ReactComponent };